export enum ErrorTypeEnum
{
  NotFound,
  NotAvailable
}
